angular
    .module('tradersyard')
    .factory('exhibition-read-filter', [
        '$flex',
        function ($flex) {
            var tab,
                hash,
                filter = {
                    init: function () {
                        hash = $flex.$hash.get();
                        tab =
                            ['timeline', 'participant', 'request', 'document', 'video', 'photo'].indexOf(hash) !== -1
                                ? hash
                                : 'timeline';
                        filter.set(tab);
                    },
                    is: function (name) {
                        return tab === name;
                    },
                    set: function (name) {
                        tab = name;
                        if (filter.on.change) filter.on.change();

                        $flex.$touch.make(name);

                        if ($flex.$hash.get() !== name) $flex.$hash.set(name);
                    },
                    tab: function () {
                        return tab;
                    },
                    on: {
                        change: undefined,
                    },
                };

            return filter;
        },
    ])
    .controller('exhibition-read-ctrl', [
        '$rootScope',
        '$scope',
        '$flex',
        'graph-exhibition-factory',
        'exhibition-read-filter',
        '$rootScope',
        'GraphParticipantService',
        'GuidFactory',
        'WebSocket',
        '$flex.array',
        '$q',
        'updatesService',
        '$window',
        'RequestManagerFactory',
        'PaginationFactory',
        '$location',
        'AuthService',
        'MeetingService',
        'datetime-common',
        function (
            $rootScope,
            $scope,
            $flex,
            exhibitionFactory,
            $filter,
            $root,
            ParticipantService,
            GuidFactory,
            $socket,
            $array,
            $q,
            $updates,
            $window,
            RequestManagerFactory,
            $paginationFactory,
            $location,
            Auth,
            MeetingService,
            $common
        ) {
            $scope.Guid = GuidFactory.Generate();
            $scope.participantRole = undefined;
            $scope.requests = 0;
            $scope.adminRoles = ['owner', 'executive', 'presenter'];

            $scope.classBooths = {
                1: 3,
                2: 5,
                3: 8,
            };

            var canceler = $q.defer();

            $scope.setParticipantRole = function (role) {
                $scope.participantRole = !!role ? role : undefined;
                setTimeout(function () {
                    $rootScope.$broadcast('participant:role', role);
                });
            };

            $scope.userCanEditComment = function (node) {
                if (!Auth.isUserAuthenticated()) {
                    return false;
                }

                if (
                    node.photos.length <= 0 &&
                    node.videos.length <= 0 &&
                    node.documents.length <= 0 &&
                    node.owner.id === $rootScope.me.id
                ) {
                    return true;
                }

                return false;
            };

            $scope.userCanDeleteMessage = function (node) {
                if (!Auth.isUserAuthenticated()) {
                    return false;
                }

                if (node.owner.id === $rootScope.me.id || $scope.adminRoles.includes($scope.participantRole)) {
                    return true;
                }

                return false;
            };

            $scope.range = function (count, start = 0) {
                return [...Array(Math.ceil(count)).keys()].filter(function (key) {
                    return key >= start;
                });
            };

            $scope.rentExhibitionBooth = function (classId) {
                if (
                    moment($scope.node.exhibition_ended_at).unix() > moment().unix() &&
                    $scope.node.im_exhibition_manager
                ) {
                    window.location.replace(`/group/create?exhibition_id=${this.node.id}&class_id=${classId}`);
                }
            };

            $scope.redirectToGroup = function (group) {
                if (group.order_completed) {
                    window.location.replace(`/group/${group.id}?autojoin=true`);
                }
            };

            $scope.getGridColumnStyles = function (countColumns, rowGap) {
                return {
                    'grid-template-columns': $scope
                        .range(countColumns)
                        .map(function (item) {
                            if (typeof rowGap !== 'undefined') {
                                return 'calc(' + (100 - rowGap * (countColumns - 1)) / countColumns + '%)';
                            }

                            return 100 / countColumns + '%';
                        })
                        .join(' '),
                };
            };

            $scope.floor = function (value) {
                return Math.floor(value);
            };

            $scope.toggleFullSizeMode = function () {
                var exhibitionPreviewMode = $('.exhibition-preview');

                if (exhibitionPreviewMode.hasClass('exhibition-preview-open')) {
                    $('.exhibition-preview').removeClass('exhibition-preview-open');
                    $('.close-full-size-icon').css('display', 'none');
                } else {
                    $('.exhibition-preview').addClass('exhibition-preview-open');
                    $('.close-full-size-icon').css('display', 'block');
                }
            };

            $scope.getFilteredWebinars = function (id) {
                var webinars = $scope.node.webinars['speaker_hall_' + id] || [];
                var currentTime = moment();

                webinars = webinars.filter(function (webinar) {
                    var startTime = moment(webinar.started_at);
                    var difference = moment.duration(startTime.diff(currentTime));

                    return difference.asMilliseconds() > 0;
                });

                if (webinars.length == 0) {
                    return false;
                }

                return webinars;
            };

            $scope.calcCountBooths = function (row, classId) {
                row = row + 1;
                var boothsCount = $scope.node['booths_class_' + classId];
                var countItems = $scope.classBooths[classId];

                return boothsCount >= countItems * row ? countItems : countItems;
            };

            $scope.getBoothGroupData = function (row, boothKey, classId) {
                var key = row * $scope.classBooths[classId] + boothKey;

                if ($scope.node.groups['class_' + classId]) {
                    return $scope.node.groups['class_' + classId][key] || undefined;
                }

                return undefined;
            };

            $scope.node = {};
            $scope.data = {};
            $scope.data.runningWebinars = {};
            angular.extend($scope, $flex.data);

            $scope.Request = RequestManagerFactory.Init($scope.node.id, 'exhibition', $scope);
            $scope.Request.Count = $scope.requests;

            // exhibitionFactory.queryRelatedProducts($scope.node.id).then(function (response) {
            //     $scope.relatedProducts = response.data.data;
            // });

            $scope.reverseOrder = true;
            $scope.sortField = 'created_at';

            $scope.sortBy = function (sortField) {
                $scope.reverseOrder = $scope.sortField === sortField ? !$scope.reverseOrder : false;
                $scope.sortField = sortField;

                $scope.participants.SortQuery({
                    field: sortField,
                    sort: $scope.reverseOrder ? 'desc' : 'asc',
                });
            };

            $scope.requestWebClientIframe = function () {
                MeetingService.triggerMeetingIframe('exhibition', $scope.node.id);
            };

            $scope.downloadParticipantsLink = function () {
                var groupId = $scope.node.id;

                return '/exhibition/' + groupId + '/participants/download';
            };

            //
            $scope.participants = ParticipantService.Get($scope.node.id, 'exhibition');
            $scope.participants.Count = $scope.node.participants;
            $socket.emit('join:exhibition', [$scope.node.id]);
            //
            $scope.filter = $filter;
            $scope.params = {
                timeline: {
                    page: 0,
                },
                participants: {
                    page: 0,
                    limit: 25,
                },
                documents: {
                    page: 0,
                },
                photos: {
                    page: 0,
                },
                videos: {
                    page: 0,
                },
            };
            $scope.timeline = [];
            $scope.posts = [];
            // $scope.participants = [];
            $scope.documents = [];
            $scope.photos = [];
            $scope.videos = [];
            $scope.progress = {
                photos: [],
                videos: [],
                documents: [],
            };
            $scope.ownerId = $scope.node.owner.id;

            $scope.Join = function (node) {
                $scope.participants.Join(node.id, $scope.Guid, function () {
                    $scope.node.participants = $scope.participants.Data;
                    $scope.node.im_participant = true;

                    if ($scope.node.technology === 'other-technology') {
                        location.replace($scope.node.technology_url);
                    } else {
                        location.reload();
                    }
                });
            };

            $scope.Leave = function (node) {
                $location.url(location.pathname);

                $scope.participants.Leave(node.id, $scope.Guid, function () {
                    $scope.node.participants = $scope.participants.Data;
                    $scope.node.im_participant = false;
                    location.reload();
                });
            };

            $root.$on('invitation-accept', function () {
                exhibitionFactory.getMyProfile().then(function (profile) {
                    if (profile.data.data.google_sync) {
                        exhibitionFactory.googleCalendarSync($scope.node);
                    }
                });
            });

            $root.$on('role-change', function (event, data) {
                window.location.reload();
            });

            $scope.assignRole = function (node) {
                $root.$broadcast('open:assign-role:dialog', {
                    node: node,
                    entry: { type: 'exhibition', id: $scope.node.id },
                });
            };

            $scope.removeParticipant = function (node) {
                $rootScope.$broadcast('open:confirm-participant-remove:dialog', {
                    node: node,
                    service: $scope.participants,
                });
            };

            $scope.selectExpire = function (node) {
                $rootScope.$broadcast('open:select-participant-expire:dialog', {
                    node: node,
                    service: $scope.participants,
                });
            };

            $scope.cancelExpire = function (node) {
                $scope.participants.Expire(node.id, (node.expired_at = null));
            };

            $scope.next_session_time = undefined;

            if (moment($scope.node.exhibition_started_at).unix() > moment().unix()) {
                $scope.next_session_time = $scope.node.exhibition_started_at;
            }

            $scope.upload = {
                descriptionImage: uploadDescriptionImage,
                headerImage: uploadHeaderImage,
                error: function (error) {
                    $root.$broadcast('graph-modal-show', {
                        title: 'Error',
                        content: error,
                    });
                },
                photo: function (node) {
                    if ($scope.photo && $scope.form.photo.$valid === true) {
                        var photo = $scope.photo;
                        $scope.progress.photos.push({
                            name: photo.name,
                        });

                        exhibitionFactory
                            .photos(node.id)
                            .upload({
                                name: $scope.photo.name,
                                photo: $scope.photo.base,
                            })
                            .then(function (response) {
                                $scope.progress.photos = $array.$splice(
                                    $scope.progress.photos,
                                    { name: photo.name },
                                    'name'
                                );

                                if (response.data.state === 0) {
                                    $scope.photos.unshift(response.data.data);

                                    if ($rootScope.$$phase != '$apply' && $rootScope.$$phase != '$digest') {
                                        $rootScope.$apply();
                                    }
                                } else {
                                    $root.$broadcast('graph-modal-show', {
                                        title: 'Error',
                                        content:
                                            response.data.data.photo ||
                                            'The file is too large or the format is incorrect.',
                                    });
                                }
                            });
                    }
                },
                video: function (node) {
                    if ($scope.video && $scope.form.video.$valid === true) {
                        var fd = new FormData();
                        fd.append('video', $scope.video.file);
                        fd.append('name', $scope.video.name);

                        var video = $scope.video;
                        $scope.progress.videos.push({
                            name: video.name,
                        });

                        exhibitionFactory
                            .videos(node.id)
                            .upload(fd, {
                                transformRequest: angular.identity,
                                headers: { 'Content-Type': undefined },
                            })
                            .then(function (response) {
                                $scope.progress.videos = $array.$splice(
                                    $scope.progress.videos,
                                    { name: video.name },
                                    'name'
                                );

                                if (response.data.state === 0) {
                                    $scope.videos.unshift(response.data.data);
                                } else {
                                    $root.$broadcast('graph-modal-show', {
                                        title: 'Error',
                                        content:
                                            response.data.data.video ||
                                            'The file is too large or the format is incorrect.',
                                    });
                                }
                            });
                    }
                },
                picture: function (node) {
                    if ($scope.picture && $scope.form.picture.$valid === true) {
                        exhibitionFactory
                            .picture(node.id)
                            .upload({
                                name: $scope.picture.name,
                                photo: $scope.picture.base,
                            })
                            .then(function (response) {
                                if (response.data.state === 0) {
                                    exhibitionFactory
                                        .picture(node.id)
                                        .attach(response.data.data.id, {})
                                        .then(function (response) {
                                            if (response.data.state === 0) {
                                                node.picture = response.data.data;
                                            }
                                        });
                                } else {
                                    $root.$broadcast('graph-modal-show', {
                                        title: 'Error',
                                        content:
                                            response.data.data.photo ||
                                            'The file is too large or the format is incorrect.',
                                    });
                                }
                            });
                    }
                },
                document: function (node) {
                    if ($scope.document && $scope.form.document.$valid === true) {
                        var fd = new FormData();
                        fd.append('document', $scope.document.file);
                        fd.append('name', $scope.document.name);

                        var document = $scope.document;
                        $scope.progress.documents.push({
                            name: document.name,
                        });

                        exhibitionFactory
                            .documents(node.id)
                            .upload(fd, {
                                transformRequest: angular.identity,
                                headers: { 'Content-Type': undefined },
                            })
                            .then(function (response) {
                                $scope.progress.documents = $array.$splice(
                                    $scope.progress.documents,
                                    { name: document.name },
                                    'name'
                                );

                                if (response.data.state === 0) {
                                    $scope.documents.unshift(response.data.data);
                                } else {
                                    $root.$broadcast('graph-modal-show', {
                                        title: 'Error',
                                        content:
                                            response.data.data.document ||
                                            'The file is too large or the format is incorrect.',
                                    });
                                }
                            });
                    }
                },
            };

            function uploadAndAttachPhoto(exhibitionEntry, file, attachFunc) {
                if (!exhibitionEntry.id) {
                    return $q.reject('Passed Exhibition object does not have an id prop');
                }

                if (!file) {
                    return $q.reject('File object not provided');
                }

                return exhibitionFactory
                    .uploadExhibitionPhoto(exhibitionEntry.id, {
                        name: file.name,
                        data64: file.base,
                    })
                    .then(attachFunc)
                    .catch(function () {
                        $root.$broadcast('graph-modal-show', {
                            title: 'Error',
                            content: 'The file is too large or the format is incorrect.',
                        });
                    });
            }

            function uploadHeaderImage(exhibitionEntry, file) {
                uploadAndAttachPhoto(exhibitionEntry, file, function (photoObj) {
                    return exhibitionFactory.attachHeaderImage(exhibitionEntry.id, photoObj.id);
                }).then(function (photoEntry) {
                    exhibitionEntry.picture = photoEntry;
                });
            }

            function uploadDescriptionImage(exhibitionEntry, file) {
                uploadAndAttachPhoto(exhibitionEntry, file, function (photoObj) {
                    return exhibitionFactory.attachDescriptionImage(exhibitionEntry.id, photoObj.id);
                }).then(function (photoEntry) {
                    exhibitionEntry.description_image = photoEntry;
                });
            }

            $scope.delete = {
                photo: function (node, index) {
                    exhibitionFactory
                        .photos($scope.node.id)
                        .delete(node.id)
                        .then(function (response) {
                            if (response.data.state === 0) {
                                $scope.photos.splice(index, 1);
                            } else {
                                $root.$broadcast('graph-modal-show', {
                                    title: 'Error',
                                    content:
                                        response.data.data.photo ||
                                        'An error occurred in the remove. Please try again later',
                                });
                            }
                        });
                },
                video: function (node, index) {
                    exhibitionFactory
                        .videos($scope.node.id)
                        .delete(node.id)
                        .then(function (response) {
                            if (response.data.state === 0) {
                                $scope.videos.splice(index, 1);
                            } else {
                                $root.$broadcast('graph-modal-show', {
                                    title: 'Error',
                                    content:
                                        response.data.data.video ||
                                        'An error occurred in the remove. Please try again later',
                                });
                            }
                        });
                },
                document: function (node, index) {
                    exhibitionFactory
                        .documents($scope.node.id)
                        .delete(node.id)
                        .then(function (response) {
                            if (response.data.state === 0) {
                                $scope.documents.splice(index, 1);
                            } else {
                                $root.$broadcast('graph-modal-show', {
                                    title: 'Error',
                                    content:
                                        response.data.data.document ||
                                        'An error occurred in the remove. Please try again later',
                                });
                            }
                        });
                },
            };

            $socket.on('comment:create', function (data) {
                if (data.place.name === 'post') {
                    $scope.posts.forEach(function (node) {
                        if (parseInt(node.id) === parseInt(data.place.id)) {
                            ++node.comments;
                            if (!$scope.$$phase) {
                                $scope.$digest();
                            }
                        }
                    });
                }
            });

            $socket.on('comment:delete', function (data) {
                if (data.place.name === 'post') {
                    $scope.posts.forEach(function (node) {
                        if (parseInt(node.id) === parseInt(data.place.id)) {
                            --node.comments;
                            if (!$scope.$$phase) {
                                $scope.$digest();
                            }
                        }
                    });
                }
            });

            $scope.load = {
                timeline: function (next) {
                    ++$scope.params.timeline.page;
                    exhibitionFactory
                        .posts($scope.node.id)
                        .query({ params: $scope.params.timeline })
                        .then(function (response) {
                            if (response.data.state === 0 && response.data.data.length > 0) {
                                $scope.posts = $scope.posts.concat(response.data.data);

                                $socket.emit(
                                    'join:post',
                                    response.data.data.map(function (item) {
                                        return item.id;
                                    })
                                );

                                if (next) next();
                            }
                        });
                },
                requests: function (next) {
                    $scope.Request.Query(next);
                },
                loadDocuments: function loadDocuments(pagination) {
                    // cancel previous request
                    canceler.resolve();
                    canceler = $q.defer();

                    $scope.params.documents.page = pagination.page;

                    return exhibitionFactory
                        .documents($scope.node.id)
                        .query({
                            // pass pagination and filters
                            params: $scope.params.documents,
                            timeout: canceler.promise,
                        })
                        .then(function (response) {
                            $scope.documents = $scope.documents.concat(response.data.data);
                            // return pagination info for <load-more-button> component
                            return {
                                totalItems: response.data.total,
                                totalPages: response.data.pages,
                            };
                        });
                },
                documents: function (next) {
                    canceler.resolve();
                    canceler = $q.defer();

                    ++$scope.params.documents.page;
                    exhibitionFactory
                        .documents($scope.node.id)
                        .query({
                            params: $scope.params.documents,
                            timeout: canceler.promise,
                        })
                        .then(function (response) {
                            if (response.data.state === 0 && response.data.data.length > 0) {
                                $scope.documents = $scope.documents.concat(response.data.data);

                                if (next) next();
                            }
                        });
                },
                photos: function (next) {
                    ++$scope.params.photos.page;
                    exhibitionFactory
                        .photos($scope.node.id)
                        .query({ params: $scope.params.photos })
                        .then(function (response) {
                            if (response.data.state === 0 && response.data.data.length > 0) {
                                $scope.photos = $scope.photos.concat(response.data.data);

                                if (next) next();
                            }
                        });
                },
                videos: function (next) {
                    ++$scope.params.videos.page;
                    exhibitionFactory
                        .videos($scope.node.id)
                        .query({ params: $scope.params.videos })
                        .then(function (response) {
                            if (response.data.state === 0 && response.data.data.length > 0) {
                                $scope.videos = $scope.videos.concat(response.data.data);

                                if (next) next();
                            }
                        });
                },
            };

            $scope.$on('touch:request', function () {
                $scope.load.requests();
            });

            $scope.filter.on.change = function () {
                $flex.$scroll.switch($scope.filter.tab());
            };

            $scope.$on('touch:timeline', function () {
                $scope.load.timeline();
            });

            $scope.$on('touch:video', function () {
                $scope.load.videos();
            });

            $scope.$on('touch:photo', function () {
                $scope.load.photos();
            });

            $scope.$on('touch:document', function () {
                $scope.documentsPagination = new $paginationFactory.paginate(function (params) {
                    return exhibitionFactory
                        .documents($scope.node.id)
                        .query({ params: params })
                        .then(function (response) {
                            return {
                                items: response.data.data,
                                totalPages: response.data.pages,
                            };
                        });
                });

                /**
                 * @param {PaginateData} paginationData
                 */
                $scope.documentsPagination.onPageLoad = function (paginationData) {
                    $scope.documents = [].concat($scope.documents, paginationData.items);
                };

                $scope.documentsPagination.onReset = function () {
                    $scope.documents = [];
                };

                $scope.$on('document-filter-update', function ($e, queryFilters) {
                    $scope.documentsPagination.reset({ queryFilters: queryFilters });
                });
            });

            $scope.$on('web-meeting:open', (event) => {
                $scope.webMeting = {
                    open: true,
                };
            });

            $scope.$on('touch:participant', function () {
                $scope.participants.Query();
            });

            $scope.$on('$historyBack', $filter.init);

            $socket.on('post:create', function (message) {
                if (
                    $scope.posts
                        .map(function (item) {
                            return Number(item.id);
                        })
                        .indexOf(Number(message.node.id)) === -1
                ) {
                    if (message.place.name === 'exhibition' && Number(message.place.id) === Number($scope.node.id)) {
                        $socket.emit('join:post', [message.node.id]);

                        if ($rootScope.me && message.node.owner.id === $rootScope.me.id) {
                            $scope.posts.unshift(message.node);

                            if (!$scope.$$phase) $scope.$digest();
                        } else {
                            $updates.appendUpdate(message.node);
                        }
                    }
                }
            });

            $scope.showUpdates = function () {
                return $updates.updatesQueue.length > 0;
            };

            $scope.cleanUpdates = function () {
                var updatesQueue = $updates.cleanUpdates();
                var defaultNodes = $scope.posts;
                $scope.posts = updatesQueue.concat(defaultNodes);
            };

            setTimeout(function () {
                window.scrollTo(0, 0);
            }, 2000);
        },
    ]);
